import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {retry} from 'rxjs/operators';
import {AGENT_NAME_URL } from '../api-config';
import {AgentName} from '../model/agent-name.model';
import {ApiService} from './api.service';
@Injectable({
  providedIn: 'root'
})
export class AgentService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) {
  }

  public getAgentByOfficeAllocation(officeAllocationId: string): Observable<AgentName> {
    let params = new HttpParams();
    params = params.set('officeAllocationId', officeAllocationId);
    return this.httpClient.get<AgentName>(this.apiService.partnerDomain + AGENT_NAME_URL, {params}).pipe(retry(5));
  }

}
